module.exports = {
  src: __webpack_public_path__ + "logo-google-play-1a51e3fb503fbbc56b5d5b380f0d5d4e.svg",
  width: 135,
  height: 40,
  bytes: 5311,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "logo-google-play-1a51e3fb503fbbc56b5d5b380f0d5d4e.svg";
};